var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { consumerTheme } from "syf-component-library/defaultTheme";
var _a = consumerTheme.meter, gradientStart = _a.gradientStart, gradientEnd = _a.gradientEnd, valueTextColor = _a.valueTextColor;
export var colors = {
    black: "#333333",
    blue: "#58a7af",
    cyanBlue: "#34657f",
    darkBlue: "#3c777c",
    darkGrey: "#9E9E9E",
    error: "#C63527",
    green: "#3e8529",
    grey: "#94969a",
    info: "#0072AD",
    lightBlue: "#e2e7ec",
    lighterBlue: "#0472ae",
    lighterGrey: "#D8D8D8",
    lightestGrey: "#F6F6F6",
    lightGrey: "#E0E0E0",
    mediumGrey: "#F8F8F8",
    navyBlue: "#274e61",
    neonGreen: "#009B19",
    orange: "#d76b00",
    red: "#ff0000",
    silver: "#767676",
    success: "#3E8529",
    warning: "#FEB600",
    white: "#FFFFFF",
    yellow: "#fbc600",
};
var components = {
    body: {
        background: "#f6f6f6",
        text: "#333333",
    },
    button: {
        background: "#34657f",
        primary: {
            text: "#FFFFFF",
            hover: "#0072ad",
        },
        secondary: {
            text: "#34657f",
            hover: "#ebf0f2",
        },
    },
    chip: {
        hover: "#f0f3f5",
        text: "#333333",
    },
    icon: "#34657f",
    link: "#34657f",
    footer: {
        background: "#FFFFFF",
        text: "#333333",
        link: "#35657f",
    },
    checkbox: {
        background: "#34657f",
        font: "#FFFFFF",
    },
    navigation: {
        activeTabText: "#34657F",
        activeTabBorder: "#34657F",
    },
    systemNavigation: {
        background: "#ffffff",
    },
    modal: {
        background: "#ffffff",
        headerBackground: "#f6f6f6",
    },
    hoverBackground: "#f0f3f5",
    datepicker: {
        legend: {
            selectedDate: {
                fill: "#34657f",
                border: "#34657f",
                text: "#ffffff",
            },
            dueDate: {
                fill: "#ffffff",
                border: "#000000",
                text: "#000000",
            },
            lateFeeDate: {
                fill: "#757575",
                border: "#757575",
                text: "#ffffff",
            },
        },
    },
    field: {
        icon: "#34657f",
        focus: "#34657f",
        label: "#34657f",
    },
    tooltip: {
        backgroundColor: "#FFFFFF",
    },
    meter: {
        valueTextColor: valueTextColor,
        gradientStart: gradientStart,
        gradientEnd: gradientEnd,
    },
    accordion: {
        borderColor: "#ffffff",
        headerBackgroundColor: "#ffffff",
        activeHeaderBackgroundColor: "#ffffff",
    },
};
var theme = __assign(__assign({}, components), colors);
export default theme;
